// 年末年始休業カレンダー: 月タブの切り替え / 締切モーダル
(function () {
  'use strict';

  function init(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sched-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.sched-cal__panel'));
    var prev = root.querySelector('[data-sched-nav="-1"]');
    var next = root.querySelector('[data-sched-nav="1"]');
    var modal = root.querySelector('[data-sched-modal]');
    var current = 0;

    function select(index, focusTab) {
      if (index < 0 || index >= tabs.length) return;
      current = index;
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('-current', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel, i) {
        panel.hidden = i !== index;
      });
      prev.disabled = index === 0;
      next.disabled = index === tabs.length - 1;
      if (focusTab) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        var to = null;
        if (e.key === 'ArrowRight') to = Math.min(i + 1, tabs.length - 1);
        else if (e.key === 'ArrowLeft') to = Math.max(i - 1, 0);
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = tabs.length - 1;
        if (to === null) return;
        e.preventDefault();
        select(to, true);
      });
    });
    prev.addEventListener('click', function () { select(current - 1); });
    next.addEventListener('click', function () { select(current + 1); });

    if (!modal || typeof modal.showModal !== 'function') return;
    var noEl = modal.querySelector('[data-sched-no]');
    var dateEl = modal.querySelector('[data-sched-date]');
    var itemsEl = modal.querySelector('[data-sched-items]');

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sched-open]');
      if (!btn) return;
      noEl.textContent = btn.getAttribute('data-no');
      dateEl.textContent = btn.getAttribute('data-date');
      itemsEl.textContent = btn.getAttribute('data-items');
      modal.showModal();
      document.documentElement.classList.add('-sched-modal');
    });
    modal.addEventListener('click', function (e) {
      // dialog 自体のクリック = backdrop のクリック
      if (e.target === modal || e.target.closest('[data-sched-close]')) modal.close();
    });
    // モーダル表示中は背面をスクロールさせない (Esc で閉じた場合も close イベントで戻す)
    modal.addEventListener('close', function () {
      document.documentElement.classList.remove('-sched-modal');
    });
  }

  function ready() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sched-calendar]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
